import { DatePipe } from '@angular/common';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ActionResultModel } from 'src/app/models/common/ActionResultModel';
import { SearchResultModel } from 'src/app/models/common/SearchResultModel';
import { ILogModel } from 'src/app/models/interfaces/ILogModel';
import { IFilterPasstModel } from 'src/app/models/interfaces/passt/IFilterPasstModel';
import { PasstCompletarModel } from 'src/app/models/passt/PasstCompletarModel';
import { PasstDetalleCompletarModel } from 'src/app/models/passt/PasstDetalleCompletarModel';
import { PasstRotuloModel } from 'src/app/models/passt/PasstRotuloModel';
import { ResumenPasstModel } from 'src/app/models/passt/ResumenPasstModel';
import { SeguimientoPasstModel } from 'src/app/models/passt/SeguimientoPasstModel';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PasstService {
  private configUrl = [environment.apiGatewayUrl, 'passt'].join('/');
  constructor(private http: HttpClient,
    private datepipe: DatePipe) { }

    getResumen(
      model: IFilterPasstModel
      // codigo: string,
      // contratista: string,
      // estado: number,
      // fecha: Date
    ): Observable<ResumenPasstModel[]> {
      let queryParams: string[] = new Array<string>();
      
      queryParams.push(`idCompania=${model.idCompania}`);
      queryParams.push(`idSede=${model.idSede}`);
      queryParams.push(`anio=${model.anio}`);
      return this.http.get<ResumenPasstModel[]>(
        `${this.configUrl}/resumen?${queryParams.join('&')}`
      );
    }

    getSeguimiento(
      model: IFilterPasstModel
      // codigo: string,
      // contratista: string,
      // estado: number,
      // fecha: Date
    ): Observable<SeguimientoPasstModel[]> {
      let queryParams: string[] = new Array<string>();
      
      queryParams.push(`idCompania=${model.idCompania}`);
      queryParams.push(`idSede=${model.idSede}`);
      queryParams.push(`anio=${model.anio}`);
      return this.http.get<SeguimientoPasstModel[]>(
        `${this.configUrl}/seguimiento?${queryParams.join('&')}`
      );
    }

    completar(model: PasstCompletarModel) {
      return this.http.post<ActionResultModel>(`${this.configUrl}/completar`, model);
    }
    updateRotulo(model: PasstRotuloModel) {
      return this.http.put<ActionResultModel>(`${this.configUrl}/rotulo/${model.idPasst}`, model);
    }
    eliminaractividad(model: PasstDetalleCompletarModel) {
      return this.http.put<ActionResultModel>(`${this.configUrl}/actividad/${model.idPasstActividad}`, model);
    }

    getComentariosActividad(
      idPasstActividad: number
    ): Observable<ILogModel[]> {
      
      return this.http.get<ILogModel[]>(`${this.configUrl}/actividad/${idPasstActividad}/comentarios`);
    }

    getComentarios(
      idPasst: number
    ): Observable<ILogModel[]> {
      
      return this.http.get<ILogModel[]>(`${this.configUrl}/${idPasst}/comentarios`);
    }

    getById(id: number): Observable<PasstRotuloModel> {
      return this.http.get<PasstRotuloModel>(`${this.configUrl}/${id}`);
    }

    exportarById(id: number): Observable<HttpResponse<Blob>> {
      return this.http.get(`${this.configUrl}/exportar/${id}`, { observe: 'response', responseType: 'blob'});
    }
}
